var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.nowPaySchemeShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "nowPayScheme" } }, [
          _c("div", { staticClass: "title" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("language.paySystem.nowPayScheme.manageYourPlan"))
              )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  _vm.nowPaySchemeShow = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.isLoading,
                expression: "isLoading"
              },
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isLoading,
                expression: "isLoading"
              }
            ],
            staticClass: "now-scheme-body",
            staticStyle: { height: "calc(100% - 80px)" },
            attrs: { "element-loading-background": "#fff" }
          }),
          _vm._v(" "),
          !_vm.isLoading
            ? _c("div", { staticClass: "now-scheme-body" }, [
                _c("div", { staticClass: "cur_plan_item" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../assets/images/paySystem/curPlanType.svg")
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("language.paySystem.supportItem.yourCurPlan")
                      ) + ":"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cur_plan_item_text" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.payInfo.payName + _vm.getInsCountStr()))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cur_plan_info" }, [
                      _c("img", {
                        attrs: {
                          src: require("../../../assets/images/paySystem/curPlanInfo.svg")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "cur_plan_info_text" }, [
                        _vm._v(
                          _vm._s(_vm.payInfo.payExtension) +
                            " " +
                            _vm._s(
                              _vm.$t(
                                "language.paySystem.nowPayScheme.clearInsCountText"
                              )
                            )
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cur_plan_item" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../assets/images/paySystem/curPlanPrice.svg")
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("language.paySystem.nowPayScheme.price")) +
                        ":"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cur_plan_item_text" }, [
                    _c("span", [
                      _c("span", { staticClass: "price" }, [
                        _vm._v(
                          _vm._s(_vm.payInfo.currency + _vm.payInfo.grossPrice)
                        )
                      ]),
                      _vm._v(" "),
                      _vm.payInfo.grossPrice != _vm.payInfo.oldPrice
                        ? _c("span", { staticClass: "old-price" }, [
                            _vm._v(
                              _vm._s(
                                _vm.payInfo.currency + _vm.payInfo.oldPrice
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v(" , ")]),
                      _vm._v(" "),
                      _vm.payInfo.vatPrice != 0
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "language.paySystem.nowPayScheme.priceVat",
                                  {
                                    currency: _vm.payInfo.currency,
                                    vatPrice: _vm.payInfo.vatPrice,
                                    percent: _vm.payInfo.percent,
                                    netPrice: _vm.payInfo.netPrice
                                  }
                                )
                              )
                            }
                          })
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cur_plan_item" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../assets/images/paySystem/curPlanCard.svg")
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("language.paySystem.nowPayScheme.paymentMethon")
                      ) + ":"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cur_plan_item_text" }, [
                    _vm.payInfo.lastFourNumber
                      ? _c("span", { staticClass: "now-scheme-tips" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "language.paySystem.nowPayScheme.defaultPayment",
                                {
                                  method: _vm.payInfo.payMethod,
                                  num: _vm.payInfo.lastFourNumber
                                }
                              )
                            )
                          )
                        ])
                      : _c("span", { staticClass: "now-scheme-tips" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "language.paySystem.nowPayScheme.paypalPayment"
                              )
                            )
                          )
                        ]),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "cur_plan_edit",
                      attrs: {
                        src: require("../../../assets/images/paySystem/curPlanEdit.svg")
                      },
                      on: {
                        click: function($event) {
                          return _vm.openClick()
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cur_plan_item" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../assets/images/paySystem/curPlanAuto.svg")
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("language.paySystem.nowPayScheme.autoRenewal")
                      ) +
                        ": " +
                        _vm._s(
                          _vm.isSubscribe
                            ? _vm.$t("language.twoStepverification.on")
                            : _vm.$t("language.twoStepverification.off")
                        )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cur_plan_item_text" }, [
                    _vm.isSubscribe
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "language.paySystem.nowPayScheme.activated",
                                { time: _vm.payInfo.nextPayTime }
                              )
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isSubscribe
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "language.paySystem.nowPayScheme.deactivated",
                                { time: _vm.payInfo.nextPayTime }
                              )
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "now-scheme-click cur_plan_item_a" },
                      [
                        _vm.isSubscribe
                          ? _c(
                              "span",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.unsubscribePlan()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("language.common.unsubscribe"))
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isSubscribe
                          ? _c(
                              "span",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.reSubscription()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("language.common.reactivate"))
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "now-scheme-close" }, [
                  _c(
                    "button",
                    {
                      staticStyle: { "border-radius": "5Px" },
                      on: {
                        click: function($event) {
                          _vm.nowPaySchemeShow = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
                  )
                ])
              ])
            : _vm._e()
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35f05fe2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35f05fe2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/pay_system_popups/now_pay_scheme_popups.vue
// module id = null
// module chunks = 